import getSymbolFromCurrency from "currency-symbol-map";

export const getCurrencySymbol = (input, isConvert = false) => {
	// let isConvert = false;
	if(input){
		if(isConvert){
			return getSymbolFromCurrency(input);
		}
		return input + " ";
	} else return "USD ";
}